import { useCallback, useState } from 'react'
import { useMountedRef } from './useMountedRef'

/**
 * @param initialValue
 * @returns a modified react 'useState' that only calls setState if the component is still mounted
 */
export const useMountedState = <T extends unknown>(initialValue: T): [T, (val: T) => void] => {
  const mounted = useMountedRef()

  const [state, _setState] = useState(initialValue)

  const setState = useCallback((value: T) => {
    if (mounted.current) {
      _setState(value)
    }
  }, [_setState, mounted])

  return [state, setState]
}
